import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import { mapActions } from 'vuex';
import {
  BLOG_BLOCK_TYPE,
  BLOG_CONTENT_ASIDE_GROUP_TYPE,
  BLOG_CONTENT_TYPE,
  COMMENT_TYPE,
  countComments
} from '@/helpers';

import ContentBlockAsideGroup from '@/components/custom/ContentBlock/ContentBlockAsideGroup/index.vue';
import ContentBlockInfo from '@/components/custom/ContentBlock/ContentBlockInfo/index.vue';
import ContentBlockTitleDescription from '@/components/custom/ContentBlock/ContentBlockTitleDescription/index.vue';
import ContentBlockImage from '@/components/custom/ContentBlock/ContentBlockImage/index.vue';
import ContentBlockVideo from '@/components/custom/ContentBlock/ContentBlockVideo/index.vue';
import ContentBlockPhrase from '@/components/custom/ContentBlock/ContentBlockPhrase/index.vue';
import CommentsBlock from '@/components/custom/CommentsBlock/index.vue';
import ContentBlockModalVideo from '@/components/custom/ContentBlock/ContentBlockModalVideo/index.vue';
import ContentBlockDescription from '@/components/custom/ContentBlock/ContentBlockDescription/index.vue';
import ContentBlockImageSide from '@/components/custom/ContentBlock/ContentBlockImageSide/index.vue';
import ContentBlockColumns from '@/components/custom/ContentBlock/ContentBlockColumns/index.vue';
import ContentBlockProduct from '@/components/custom/ContentBlock/ContentBlockProduct/index.vue';
import ContentBlockReview from '@/components/custom/ContentBlock/ContentBlockReview/index.vue';
import ContentBlockAuthor from '@/components/custom/ContentBlock/ContentBlockAuthor/index.vue';
import ShareBlock from '@/components/custom/ShareBlock/index.vue';

export default {
  name: 'ContentBlock',
  components: {
    ShareBlock,
    ContentBlockAuthor,
    ContentBlockReview,
    ContentBlockProduct,
    ContentBlockColumns,
    ContentBlockImageSide,
    ContentBlockDescription,
    ContentBlockModalVideo,
    CommentsBlock,
    ContentBlockPhrase,
    ContentBlockVideo,
    ContentBlockImage,
    ContentBlockTitleDescription,
    ContentBlockInfo,
    ContentBlockAsideGroup,
    BreadcrumbsSimple
  },
  props: {
    breadcrumbsTitle: {
      type: String,
      default: ''
    },
    breadcrumbsList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    data: {
      type: [Object, Array, null],
      default: () => null
    },
    meta: {
      type: [Object, null],
      default: () => null
    },
    type: {
      type: String,
      default: BLOG_CONTENT_TYPE.CONTENTS
    },
    isHasAside: {
      type: Boolean,
      default: true
    },
    isCropImg: {
      type: Boolean,
      default: false
    },
    isHasMainImg: {
      type: Boolean,
      default: false
    },
    isBigTitles: {
      type: Boolean,
      default: false
    },
    isCanShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      COMMENT_TYPE,
      BLOG_CONTENT_TYPE,
      BLOG_BLOCK_TYPE,
      asideData: [],
      commentsCount: null
    };
  },
  watch: {
    data: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          if (this.data.comments && this.data.comments.data.length) {
            this.commentsCount = countComments(this.data.comments.data, COMMENT_TYPE.COMMENTS);
          }
        }
      }
    }
  },
  async created() {
    if (this.isHasAside) {
      await this._loadContent();
    }
  },
  mounted() {},
  computed: {
    author() {
      return this.data?.author?.data || null;
    },
    contents() {
      let contents = [];

      if (this.data.contents && this.data.contents.data.length) {
        contents = this.data.contents.data;
      } else if (this.data.pageContents && this.data.pageContents.data.length) {
        contents = this.data.pageContents.data;
      }

      let columns = [];
      let result = [];

      result.push({
        id: 73,
        news_id: 9937,
        image: '',
        image2: '',
        image_title: '',
        status: true,
        video: '',
        position: 1,
        title: '',
        description: 'тест',
        type: 'review',
        review: {
          data: {
            id: 411,
            parent_id: 0,
            product_id: 9128,
            user_id: 0,
            rating: 5,
            message: 'Використовую для зволоження шкіри зранку, та є прекрасною основою під макіяж.',
            email: '',
            name: 'Юлія',
            visible: true,
            created_at: 'Сентябрь 2025',
            files: [],
            child: [],
            product: {
              data: {
                id: 9128,
                product_group_id: 0,
                slug: 'zvolozhuvalnij-krem-z-illyuminuyuchim-efektom',
                position: 6,
                type: 'regular',
                is_popular: false,
                is_sample: false,
                is_new: true,
                is_coming_soon: false,
                image:
                  'https://api.renew.net.ua/storage/%D0%A2%D0%BE%D0%B2%D0%B0%D1%80%D0%B8/%D0%90QUALIA/NEW%20HYDRO%20COMFORT%20GLOW%20MOISURIZER-01.png',
                image_2: '',
                video: null,
                average_rating: 0,
                title: 'Увлажняющий крем с иллюминирующим эффектом',
                sub_title: 'Hydro Comfort Glow Moisturizer',
                short_description: '',
                description:
                  '<div style="text-align: justify;">Настоящая магия для твоей кожи &ndash; это увлажняющий крем с иллюминирующим эффектом SPF-25! Легкая текстура мгновенно дарит коже сияние и здоровый вид. Эффект шимера работает как лучший хайлайтер на твоем лице!<br />\r\nКрем поддерживает идеальный баланс увлажненности, восстанавливает барьер кожи и улучшает кровообращение, благодаря современным стабильным фильтрам (SPF-25), он также защищает от свободных радикалов и солнечных лучей, даря тебе защиту в течение дня.<br />\r\n<br />\r\nСпециальная формула выравнивает тон и рельеф кожи, разглаживает мелкие морщинки и обеспечивает комфортное увлажнение на весь день. Твоя кожа будет выглядеть отдохнувшей и здоровой без усилий!<br />\r\nПрекрасная основа под макияж и надежная солнцезащита.<br />\r\n<br />\r\n<strong>Применение: </strong>Наносить крем на очищенную сухую кожу лица, шеи и декольте утром &mdash; и твоя кожа будет чувствовать себя комфортно в течение всего дня.</div>',
                syllable: '',
                video_title: '',
                meta_title: 'Увлажняющий крем с иллюминирующим эффектом',
                meta_description: '',
                has_active_promotion: null,
                brand: {
                  id: 775,
                  slug: 'aqualia',
                  title: 'AQUALIA: Восстановление и экстраувлажнение'
                },
                product_prices: [],
                images: [],
                recommendations: [],
                faqs: [],
                feedbacks: [],
                has_duplicate: false,
                max_count: 0
              }
            }
          }
        }
      });

      for (let block of contents || []) {
        if (block.type === BLOG_BLOCK_TYPE.COLUMN_BLOCK) {
          columns.push(block);
          continue;
        }
        if (columns.length) {
          result.push({
            id: columns[0].id,
            type: BLOG_BLOCK_TYPE.COLUMN_BLOCK,
            columns
          });
          columns = [];
        }
        result.push(block);
      }

      console.log('result', result);
      return result;
    }
  },
  methods: {
    ...mapActions({
      getBlogFresh: 'blog/GET_BLOG_FRESH',
      getBlogCategories: 'blog/GET_BLOG_CATEGORIES'
    }),
    async _loadContent() {
      let promiseCollection = [];
      let data = {};
      promiseCollection.push(this.getBlogFresh().then((result) => (data['fresh'] = result)));
      promiseCollection.push(this.getBlogCategories().then((result) => (data['categories'] = result)));
      await Promise.all(promiseCollection);
      this._prepareAside(data);
    },
    _prepareAside({ fresh, categories }) {
      if (fresh?.length) {
        this.asideData.push({
          title: this.$t('block.contentAside.fresh'),
          list: fresh.map(({ title, slug }) => ({ title, route: { name: 'news-single', params: { slug } } })),
          type: BLOG_CONTENT_ASIDE_GROUP_TYPE.FRESH
        });
      }

      if (categories?.length) {
        this.asideData.push({
          title: this.$t('block.contentAside.categories'),
          list: categories.map(({ title, slug, newsCount }) => ({
            title: title ? title : slug,
            route: { path: `/${slug}` },
            count: newsCount
          })),
          type: BLOG_CONTENT_ASIDE_GROUP_TYPE.CATEGORIES
        });
      }
    },
    onUpdateCounter() {
      this.commentsCount++;
    }
  }
};
